<template>
	<div class="sys-auth vue-padding radius" style="height: 742px">
		<!-- <div class="tips">{{$route.name}}</div> -->
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane :label="$t('authorization.userRole')" name="userRole">
				<user-role :roleList="roleList"></user-role>
			</el-tab-pane>
			<el-tab-pane :label="$t('authorization.roleAuth')" name="userAuth">
				<role-auth :roleList="roleList"></role-auth>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import userRole from "_c/authority/auth/UserRole";
import roleAuth from "_c/authority/auth/RoleAuth";
import { checkPerm, checkRole } from "../../utils/permission";

export default {
	name: "Authorization",
	components: {
		roleAuth,
		userRole,
	},
	inject: ["reload"],
	data() {
		return {
			activeName: "userRole",
			roleList: [],
			defaultProps: {
				label: "name",
				children: "children",
			},
		};
	},
	mounted() {
		this.$api
			.request(this.$url.AuthorityRole.loadRole, this.$method.get)
			.then(res => {
				if (res.code === 0) {
					this.roleList = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
			.catch(() => {
				this.$message.error(this.$t("authorization.roleFail"));
			});
	},
	methods: {
		handleClick(tab) {},
		checkPerm,
		checkRole,
	},
};
</script>

<style lang="scss">
.sys-auth {
	.el-input {
		width: 100%;
	}

	.roleFilter,
	.authFilter {
		padding-left: 20px;
		margin-bottom: 10px;
	}

	.el-tree-node__content {
		height: 30px;
		line-height: 30px;
	}
}
</style>
